module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAK1JREFUKFM9jisOwlAURM8lhKQJklr2gEeAYBPsAkFagcCR1LACUISQsAcE7ADBCjB8CqKyaYe8vhY1mbmTM9eYKQg7HGVMEDfBOg3YsbQSwHqx5kDiTBV4uRQl009id1e4GAxdqqog5GsP5YwsjPUUhM25IdV6doQc1P7D6xlHA76ukBl0vf/j/UjJwnqRTpjGnuC/MEgxotfKNu6HgWAP9A2uhTi0xPadWOYgP32rPoADugsUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/image2/shape.png
// module id = v5vG
// module chunks = 28